import React, { useState, useEffect } from "react";
import { User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { UserItem } from "../UserItem";
import { Pagination } from "../../../Shared";

const userController = new User();

export function ListUsers(props) {
  const { usersActive, reload, onReload } = props;
  const [users, setUsers] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setUsers(null);
        const response = await userController.getUsers(accessToken, usersActive, page);
        setUsers(response.docs);
        setPagination({
          limit: response.limit,
          page: response.page,
          pages: response.pages,
          total: response.total,
        });
      } catch (error) {
        console.error(error);
      }
    })();
  }, [page, usersActive, reload, accessToken]);

  if (!users) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-2 border-[#151C84]/20 border-t-[#151C84] rounded-full animate-spin" />
          <p className="text-sm text-gray-400">Cargando usuarios...</p>
        </div>
      </div>
    );
  }

  if (users.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-14 h-14 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <svg className="w-7 h-7 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        <p className="text-gray-500 font-semibold">No hay usuarios {usersActive ? "activos" : "inactivos"}</p>
        <p className="text-gray-400 text-sm mt-1">
          {usersActive ? "Crea un nuevo usuario para comenzar." : "Todos los usuarios están activos."}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="space-y-2">
        {users.map((user, index) => (
          <UserItem key={index} user={user} onReload={onReload} />
        ))}
      </div>

      {pagination && (
        <Pagination
          page={page}
          pages={pagination.pages}
          onPage={setPage}
          total={pagination.total}
          shown={users.length}
          label="usuarios"
        />
      )}
    </div>
  );
}
